
import { Options, Vue } from 'vue-class-component';
import { ProviderClient } from '@/services/Services';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: {}
})
export default class Providers extends Vue {

    providers: OM.ProviderListInfoVM[] = [];
    isReadOnly: boolean = false;

    created() {
        this.init();
        this.isReadOnly = store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    init() {
        ProviderClient.getAllByCompany()
        .then(x => {
            this.providers = x;
        })
    }

    deleteProvider(providerIdentifier: string) {
        if(confirm("Do you really want to delete?")) {
            ProviderClient.deleteProvider(providerIdentifier)
            .then(x => {
                this.init();
            })
        }
    }

}
